import httpservice from "./httpservice";

class FileDownload {
  /**
   * Download a file from an API path as a blob.
   * @param {string} path
   * @param {string} fileName
   * @param {(updater: Function) => void} [callback]
   * @param {object} [params]
   */
  async download(path, fileName, callback, params = {}) {
    try {
      const res = await httpservice.axios({
        url: path,
        method: "GET",
        responseType: "blob",
        params,
        onDownloadProgress: (progressEvent) => {
          if (callback) {
            callback((prev) => ({ ...prev, progressEvent, downloading: true }));
          }
        },
      });

      const contentType = res?.headers?.["content-type"] || "";
      if (contentType.includes("application/json")) {
        const text = await res.data.text();
        const json = JSON.parse(text);
        const error = new Error(json?.message || "Export failed");
        error.response = { data: json, status: res.status };
        throw error;
      }

      const href = URL.createObjectURL(res?.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      return res;
    } catch (error) {
      // Axios may wrap JSON errors as blobs when responseType is blob.
      if (error?.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          error.response.data = json;
        } catch (_) {
          // keep original error
        }
      }
      throw error;
    }
  }
}

export default new FileDownload();
